import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import PaintCalculator from "../components/PaintCalculator";
import Herovis2 from "../components/Herovis2";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";
export default function PCalculator() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <Herovis2 />
      <PaintCalculator />
      <FAQ />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
